import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ReportCycle} from '../../../admin/models/report-cycle.interface';
import {appConfig} from '../../../config/config';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';

@Component({
  selector: 'app-report-cycles-table',
  templateUrl: './report-cycles-table.component.html',
  styleUrls: ['./report-cycles-table.component.scss']
})
export class ReportCyclesTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'unuKeySetName', 'kfCategorySetName', 'collectionStreamName', 'launched', 'open', 'actions'];

  @Input()
  reportCycles!: ReportCycle[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadReportCycles: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  printReportCycle: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  openReportCycle: EventEmitter<ReportCycle> = new EventEmitter<ReportCycle>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor() {
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadReportCycles.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadReportCycles.emit({page: event.pageIndex, size: event.pageSize});
  }

  print(year: number): void {
    this.printReportCycle.emit(year);
  }

  openCharts(reportCycle: ReportCycle): void {
    this.openReportCycle.emit(reportCycle);
  }
}
